import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getData } from "../services/api.service";
import BackButton from "../components/common/BackButton";
import Image from "../assets/img/H1.png";
import Image2 from "../assets/img/Order.png";

import BottomNav from "../components/order_food/BottomNav";

const OrderChooseSize = () => {
  const { type_id, branch_id } = useParams();
  const [sizes, setSizes] = useState([]);
  const navigate = useNavigate();

  const handleSizeSelect = (size) => {
    navigate(
      `/home/food_order/${branch_id}/burguer_type/${type_id}/size/${size.id}`,
      {
        state: {
          size_short_desc: size.size_short_desc,
          base_price: size.base_price,
          extra_cheese_price: size.extra_cheese_price,
        },
      }
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getData(
          `/api/get_burguer_sizes_by_type/${type_id}/${branch_id}`
        );
        if (res.status === 200) {
          const burgerSizes = res.data.burger_sizes;
          setSizes(burgerSizes);
          if (burgerSizes.length === 0) {
            navigate("/home/food_order");
          }
        } else {
          console.log("Error fetching burger sizes");
          navigate("/home/food_order");
        }
      } catch (error) {
        navigate("/home/food_order");
      }
    };

    fetchData();
  }, [type_id, navigate]);

  return (
    <>
      <div className="container text-white mt-3 position-relative ">
        <div className="mb-5">
          <BackButton />
        </div>
        <h1 className="text-center mb-4">Selecciona el tamaño de tu Billy</h1>

        <div className="row justify-content-center">
          {sizes.map((size) => (
            <div
              key={size.id}
              className="col-6 col-md-4 col-lg-3 mb-4 d-flex justify-content-center"
            >
              <button
                className="card text-center text-black p-3 w-100 bg-beige "
                style={{
                  border: "none",
                  color: "#fff",
                }}
                key={size.id}
                onClick={() => handleSizeSelect(size)}
              >
                <h4 className="fw-bold">{size.size_short_desc}</h4>
                {/* <img
                  src={Image}
                  alt={size.size_description}
                  className="img-fluid mb-2"
                  style={{ maxHeight: "60px", objectFit: "contain" }}
                /> */}
                <p>{size.size_description}</p>
                <strong>${size.base_price}</strong>
              </button>
            </div>
          ))}
        </div>

        <img
          src={Image2}
          alt="LogoBottom"
          className="position-absolute"
          style={{ right: "0", zIndex: 10 }}
        />

        <BottomNav id_branch={branch_id} />
      </div>
    </>
  );
};

export default OrderChooseSize;
